module.exports = __webpack_public_path__ + "img/4.3.aa691866.png";